import BoxUi from '@components/common/BoxUi'
import React from 'react'
import DetalleCard from './DetalleCard'

const Detalles = ({ data }) => data.map((item, index) => (
    <BoxUi background={index % 2} key={item.id}>
        <DetalleCard {...item} />
    </BoxUi>
))

export default Detalles